import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 600,
      "data-sign": "shop_mapping_change_default_modal",
      "title": _vm.t('变更默认主体')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-alert', {
    staticClass: "mb-15",
    attrs: {
      "type": "warning",
      "show-icon": "",
      "message": _vm.t('变更后，原默认主体将被解绑，新主体将自动绑定并设为该国的默认结算主体。入库/保价/转运/仓租/特殊退件费用新单据将按新主体结算。')
    }
  }), _c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "shop_mapping_change_default_form",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 14
      },
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E97\u94FA\u7F16\u7801"),
      "label": _vm.t('店铺编码')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.record.shop_code,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E97\u94FA\u540D\u79F0"),
      "label": _vm.t('店铺名称')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.record.shop_name,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4E1A\u52A1\u53D1\u751F\u56FD"),
      "label": _vm.t('业务发生国')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.formatCountryList(_vm.record.country_list),
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5F53\u524D\u9ED8\u8BA4\u4E3B\u4F53"),
      "label": _vm.t('当前默认主体')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.record.account_code + "-" + _vm.record.sign_body_name,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u76EE\u6807\u5E97\u94FA"),
      "prop": "target_shop_code",
      "label": _vm.t('目标店铺')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "option-filter-prop": "children",
      "placeholder": _vm.t('请选择目标店铺')
    },
    model: {
      value: _vm.formData.target_shop_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "target_shop_code", $$v);
      },
      expression: "formData.target_shop_code"
    }
  }, _vm._l(_vm.shopList, function (item) {
    return _c('a-select-option', {
      key: item.shop_code,
      attrs: {
        "value": item.shop_code
      }
    }, [_vm._v(" " + _vm._s(item.shop_code) + " " + _vm._s(item.shop_name) + " (" + _vm._s(item.account_code) + "-" + _vm._s(item.sign_body_name) + ") ")]);
  }), 1)], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "shop_mapping_change_cancel",
      "id": "shop_mapping_change_cancel",
      "data-sign": "shop_mapping_change_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading,
      "data-permission": "shop_mapping_change_confirm",
      "id": "shop_mapping_change_confirm",
      "data-sign": "shop_mapping_change_confirm",
      "fbu-analyse-name": $t("\u786E\u8BA4")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确认')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };